module.exports = __webpack_public_path__ + "files/0dea96c27441c30c7d4a5431844adba8.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-16.png
// module id = 1505
// module chunks = 60